export type LinkSectionType = {
  title: string;
  links: Array<{ text: string; href: string }>;
};

// prettier-ignore
export const TopSearchesSection: LinkSectionType = {
  title: 'Top Searches',
  links: [
    {
      text: 'Slack Integrations',
      href: '/apps/slack/integrations',
    },
    {
      text: 'Salesforce Integrations',
      href: '/apps/salesforce/integrations',
    },
    {
      text: 'HubSpot CRM Integrations',
      href: '/apps/hubspot-crm/integrations',
    },
    {
      text: 'PayPal Integrations',
      href: '/apps/paypal/integrations',
    },
    {
      text: 'Asana Integrations',
      href: '/apps/asana/integrations',
    },
    {
      text: 'Stripe Integrations',
      href: '/apps/stripe/integrations',
    },
    {
      text: 'GitHub Integrations',
      href: '/apps/github/integrations',
    },
    {
      text: 'Trello Integrations',
      href: '/apps/trello/integrations',
    },
    {
      text: 'Todoist Integrations',
      href: '/apps/todoist/integrations',
    },
    {
      text: 'Xero Integrations',
      href: '/apps/xero/integrations',
    },
    {
      text: 'Zapier Integrations',
      href: '/apps/zapier/integrations',
    },
    {
      text: 'Facebook Groups Integrations',
      href: '/apps/facebook-groups/integrations',
    },
    {
      text: 'JIRA Integrations',
      href: '/apps/jira/integrations',
    },
    {
      text: 'Pipedrive Integrations',
      href: '/apps/pipedrive/integrations',
    },
    {
      text: 'Zendesk Integrations',
      href: '/apps/zendesk/integrations',
    },
    {
      text: 'Google Analytics Integrations',
      href: '/apps/google-analytics/integrations',
    },
    {
      text: 'HipChat Integrations',
      href: '/apps/hipchat/integrations',
    },
    {
      text: 'MailChimp Integrations',
      href: '/apps/mailchimp/integrations',
    },
    {
      text: 'Shopify Integrations',
      href: '/apps/shopify/integrations',
    },
    {
      text: 'Intercom Integrations',
      href: '/apps/intercom/integrations',
    },
    {
      text: 'GitLab Integrations',
      href: '/apps/gitlab/integrations',
    },
    {
      text: 'Magento 2.X Integrations',
      href: '/apps/magento-v2/integrations',
    },
    {
      text: 'Google Drive Integrations',
      href: '/apps/google-drive/integrations',
    },
    {
      text: 'WooCommerce Integrations',
      href: '/apps/woocommerce/integrations',
    },
    {
      text: 'Basecamp 3 Integrations',
      href: '/apps/basecamp3/integrations',
    },
  ],
};

// prettier-ignore
export const PopularAppsSection: LinkSectionType = {
  title: 'Popular Apps',
  links: [
    {
      text: 'Dropbox',
      href: '/apps/dropbox/integrations',
    },
    {
      text: 'Google Sheets',
      href: '/apps/google-sheets/integrations',
    },
    {
      text: 'DocuSign',
      href: '/apps/docusign/integrations',
    },
    {
      text: 'WordPress',
      href: '/apps/wordpress/integrations',
    },
    {
      text: 'Office 365',
      href: '/apps/office-365/integrations',
    },
    {
      text: 'QuickBooks Online',
      href: '/apps/quickbooks/integrations',
    },
    {
      text: 'Mixpanel',
      href: '/apps/mixpanel/integrations',
    },
    {
      text: 'RingCentral',
      href: '/apps/ringcentral/integrations',
    },
    {
      text: 'Zoho CRM',
      href: '/apps/zoho-crm/integrations',
    },
    {
      text: 'HubSpot',
      href: '/apps/hubspot/integrations',
    },
    {
      text: 'Microsoft Teams',
      href: '/apps/microsoft-teams/integrations',
    },
    {
      text: 'Eventbrite',
      href: '/apps/eventbrite/integrations',
    },
    {
      text: 'Box',
      href: '/apps/box/integrations',
    },
    {
      text: 'Evernote Business',
      href: '/apps/evernote-business/integrations',
    },
    {
      text: 'LinkedIn',
      href: '/apps/linkedin/integrations',
    },
    {
      text: 'Marketo',
      href: '/apps/marketo/integrations',
    },
    {
      text: 'SugarCRM',
      href: '/apps/sugarcrm/integrations',
    },
    {
      text: 'Twilio',
      href: '/apps/twilio/integrations',
    },
    {
      text: 'Infusionsoft',
      href: '/apps/infusionsoft/integrations',
    },
    {
      text: 'Google Forms',
      href: '/apps/google-forms/integrations',
    },
    {
      text: 'SurveyMonkey',
      href: '/apps/surveymonkey/integrations',
    },
    {
      text: 'Campaign Monitor',
      href: '/apps/campaign-monitor/integrations',
    },
    {
      text: 'Pardot',
      href: '/apps/pardot/integrations',
    },
    {
      text: 'Microsoft Dynamics CRM',
      href: '/apps/microsoft-dynamics/integrations',
    },
  ],
};

// prettier-ignore
export const TrendingAppsSection: LinkSectionType = {
  title: 'Trending Apps',
  links: [
    {
      text: 'Twitch',
      href: '/apps/twitch/integrations',
    },
    {
      text: 'Printful',
      href: '/apps/printful/integrations',
    },
    {
      text: 'Microsoft To-Do',
      href: '/apps/microsoft-todo/integrations',
    },
    {
      text: 'Microsoft Outlook',
      href: '/apps/microsoft-outlook/integrations',
    },
    {
      text: 'Medium',
      href: '/apps/medium/integrations',
    },
    {
      text: 'Unbounce',
      href: '/apps/unbounce/integrations',
    },
    {
      text: 'Freshdesk',
      href: '/apps/freshdesk/integrations',
    },
    {
      text: 'Airtable',
      href: '/apps/airtable/integrations',
    },
    {
      text: 'Expensify',
      href: '/apps/expensify/integrations',
    },
    {
      text: 'Insightly',
      href: '/apps/insightly/integrations',
    },
    {
      text: 'PagerDuty',
      href: '/apps/pagerduty/integrations',
    },
    {
      text: 'Podio',
      href: '/apps/podio/integrations',
    },
    {
      text: 'Wunderlist',
      href: '/apps/wunderlist/integrations',
    },
    {
      text: 'Square',
      href: '/apps/square/integrations',
    },
    {
      text: 'Datadog',
      href: '/apps/datadog/integrations',
    },
    {
      text: 'Toggl',
      href: '/apps/toggl/integrations',
    },
    {
      text: 'ClickFunnels',
      href: '/apps/clickfunnels/integrations',
    },
    {
      text: 'Rocket.Chat',
      href: '/apps/rocketchat/integrations',
    },
    {
      text: 'Firebase',
      href: '/apps/firebase/integrations',
    },
    {
      text: 'Cisco Spark',
      href: '/apps/cisco-spark/integrations',
    },
    {
      text: 'MINDBODY',
      href: '/apps/mindbody/integrations',
    },
    {
      text: 'Harvest',
      href: '/apps/harvest/integrations',
    },
    {
      text: 'Smartsheet',
      href: '/apps/smartsheet/integrations',
    },
    {
      text: 'Teamwork Desk',
      href: '/apps/teamwork-desk/integrations',
    },
    {
      text: 'Yammer',
      href: '/apps/yammer/integrations',
    },
    {
      text: 'Typeform',
      href: '/apps/typeform/integrations',
    },
    {
      text: 'Autotask',
      href: '/apps/autotask/integrations',
    },
    {
      text: 'Wrike',
      href: '/apps/wrike/integrations',
    },
    {
      text: 'Help Scout',
      href: '/apps/help-scout/integrations',
    },
    {
      text: 'Braintree',
      href: '/apps/braintree/integrations',
    },
  ],
};

// prettier-ignore
export const TopAppsByCategorySection: LinkSectionType = {
  title: 'Top Apps by Category',
  links: [
    {
      text: 'Project Management',
      href: '/apps/categories/project-management',
    },
    {
      text: 'Calendar',
      href: '/apps/categories/calendar',
    },
    {
      text: 'Email',
      href: '/apps/categories/email',
    },
    {
      text: 'CRM (Customer Relationship Management)',
      href: '/apps/categories/crm',
    },
    {
      text: 'Marketing Automation',
      href: '/apps/categories/marketing',
    },
    {
      text: 'Notes',
      href: '/apps/categories/notes',
    },
    {
      text: 'Accounting',
      href: '/apps/categories/accounting',
    },
    {
      text: 'Social Media Marketing',
      href: '/apps/categories/social-marketing',
    },
    {
      text: 'Online Courses',
      href: '/apps/categories/education',
    },
    {
      text: 'Contact Management',
      href: '/apps/categories/contacts',
    },
    {
      text: 'Forms & Surveys',
      href: '/apps/categories/forms',
    },
    {
      text: 'Scheduling & Booking',
      href: '/apps/categories/scheduling',
    },
    {
      text: 'Task Management',
      href: '/apps/categories/todo-lists',
    },
    {
      text: 'Databases',
      href: '/apps/categories/databases',
    },
    {
      text: 'Call Tracking',
      href: '/apps/categories/call-tracking',
    },
    {
      text: 'Documents',
      href: '/apps/categories/documents',
    },
    {
      text: 'Fax',
      href: '/apps/categories/fax',
    },
    {
      text: 'Files',
      href: '/apps/categories/files',
    },
    {
      text: 'Customer Support',
      href: '/apps/categories/customer-support',
    },
    {
      text: 'Team Collaboration',
      href: '/apps/categories/team-collaboration',
    },
    {
      text: 'Spreadsheets',
      href: '/apps/categories/spreadsheets',
    },
    {
      text: 'Website Builders',
      href: '/apps/categories/cms',
    },
    {
      text: 'Ecommerce',
      href: '/apps/categories/ecommerce',
    },
    {
      text: 'Event Management',
      href: '/apps/categories/event-management',
    },
  ],
};

// prettier-ignore
export const OurBestContentSection: LinkSectionType = {
  title: 'Our Best Content',
  links: [
    {
      text: 'Best Video Conferencing Apps',
      href: '/blog/best-video-conferencing-apps',
    },
    {
      text: 'Best Email Apps',
      href: '/blog/best-email-app/',
    },
    {
      text: 'Best CRM Apps',
      href: '/learn/crm/best-crm-app/',
    },
    {
      text: 'Best Note Taking Apps',
      href: '/blog/best-note-taking-apps/',
    },
    {
      text: 'Best Calendar Apps',
      href: '/blog/best-calendar-apps/',
    },

    {
      text: 'Best Meeting Scheduler Apps',
      href: '/blog/best-meeting-scheduler-apps/',
    },
    {
      text: 'Best Todo List Apps',
      href: '/blog/best-todo-list-apps/',
    },
    {
      text: 'Best Powerpoint Alternatives',
      href: '/blog/best-powerpoint-alternatives/',
    },
    {
      text: 'Best Spreadsheet & Excel Alternatives',
      href: '/blog/best-spreadsheet-excel-alternative/',
    },
    {
      text: 'Best Time Tracking Apps',
      href: '/blog/best-time-tracking-apps/',
    },
    {
      text: 'Best eCommerce Shopping Cart Software',
      href: '/blog/best-ecommerce-shopping-cart-software/',
    },
    {
      text: 'Best Survey Apps',
      href: '/learn/forms-surveys/best-survey-apps/',
    },
    {
      text: 'Best Online Form Builder Software',
      href: '/learn/forms-surveys/best-online-form-builder-software/',
    },
    {
      text: 'Best Digital Signature Apps',
      href: '/blog/best-digital-signature-apps/',
    },
    {
      text: 'Best Team Chat App',
      href: '/blog/best-team-chat-app/',
    },
  ],
};
